module.exports = __webpack_public_path__ + "static/media/mandibular-placa.383263d1.png";